<template>
  <div class="tab-content">
    <h4 class="section-title">Data Dokumen</h4>

    <div class="form-fields">
      <div class="field">
        <label>Nomor Dokumen <span class="required">*</span></label>
        <div class="field-value">{{ data.nomorDokumen }}</div>
      </div>

      <div class="two-col">
        <div class="field">
          <label>Tanggal Terbit <span class="required">*</span></label>
          <div class="field-value">{{ data.tanggalTerbit }}</div>
        </div>
        <div class="field">
          <label>Tanggal Berakhir <span class="required">*</span></label>
          <div class="field-value">{{ data.tanggalBerakhir }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberApplicationTabDataDokumen',
  props: {
    data: { type: Object, required: true },
  },
}
</script>

<style scoped>
.tab-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #282828;
  margin: 0;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field label {
  font-size: 14px;
  font-weight: 700;
  color: #444;
}

.required {
  color: #dc3545;
}

.field-value {
  background: #e4e9f0;
  border: 1px solid #e4e9f0;
  border-radius: 6px;
  padding: 4px 16px;
  min-height: 32px;
  font-size: 14px;
  color: #444;
  line-height: 22px;
  display: flex;
  align-items: center;
}
</style>
